import React, { useMemo } from "react";
import styles from "./Style.module.css";
import useProductTable from "./ProductTable.hook";
import constants from "../../../../../config/constants";
import DataTables from "../../../../../Datatables/Datatable.table";
import { Typography } from "@mui/material";
import ShadowBox from "../../../../../components/ShadowBox/ShadowBox";

const ProductTable = ({ programId, renderList }) => {
  const {
    handleSortOrderChange,
    handleRowSize,
    handlePageChange,
    isCalling,
    data,
    currentData,
    currentPage,
    isFetching,
  } = useProductTable({ programId, renderList });

  const tableStructure = useMemo(() => {
    return [
      {
        key: "code",
        label: "Product Code",
        sortable: false,
        render: (temp, all) => <div>{all?.product_code}</div>,
      },
      {
        key: "name",
        label: "Product Name",
        sortable: false,
        render: (temp, all) => <div>{all?.product_name}</div>,
      },
      {
        key: "generic",
        label: "Generic Name",
        sortable: false,
        render: (temp, all) => <div>{all?.generic_name}</div>,
      },
      {
        key: "strength",
        label: "Strength",
        sortable: false,
        render: (temp, all) => <div>{all?.strength}</div>,
      },
      {
        key: "strength",
        label: "Net Content",
        sortable: false,
        render: (temp, all) => <div>{all?.net_content}</div>,
      },
      {
        key: "strength",
        label: "Dosage Form",
        sortable: false,
        render: (temp, all) => <div>{all?.dose_form}</div>,
      },
    ];
  }, [isCalling]);

  const tableData = useMemo(() => {
    const datatableFunctions = {
      onSortOrderChange: handleSortOrderChange,
      onPageChange: handlePageChange,
      onRowSizeChange: handleRowSize,
    };

    const datatable = {
      ...constants.DATATABLE_PROPERTIES,
      columns: tableStructure,
      data: currentData,
      count: data.length,
      page: currentPage - 1,
      rowsPerPage: 10,
      allRowSelected: false,
      showSelection: false,
    };

    return { datatableFunctions, datatable };
  }, [
    tableStructure,
    handleSortOrderChange,
    handlePageChange,
    handleRowSize,
    currentData,
    currentPage,
    data,
  ]); // allData,

  return data?.length > 0 ? (
    <ShadowBox className={styles.product}>
      <div className={styles.mainContainer}>
        <div className={styles.row1}>
          <Typography
            variant={"h5"}
            className={styles.productHeading}
            color={"text.primary"}
          >
            {" "}
            Program Master Details
          </Typography>
        </div>
        <br />
        <DataTables
          {...tableData.datatable}
          {...tableData.datatableFunctions}
        />
      </div>
    </ShadowBox>
  ) : (
    <></>
  );
};

export default ProductTable;
